import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './Well.css';

export type WellTone = 'page' | 'stage';

export interface WellProps {
  children: ReactNode;
  /**
   * page — the page colour, so a nested Panel keeps its hairline.
   * stage — a bordered surface for a live demo.
   */
  tone?: WellTone;
  className?: string;
  testId?: string;
}

export function Well({ children, tone = 'page', className, testId }: WellProps) {
  return (
    <div className={classes('well', tone === 'stage' && 'well--stage', className)} {...testIdAttr(testId)}>
      {children}
    </div>
  );
}
